import { gql } from "../__generated__/gql";

gql(`
    fragment LegalEmployerFields on LegalEmployer {
        id
        name
        marketingName
        useLseCct
    }
`);

gql(`
    fragment AddressFields on Address {
        formatted
        route
        streetNumber
        longitude
        latitude
        locality {
            name
            postalCode
            state {
                name
                code
                country {
                    name
                    code
                }
            }
        }
    }
`);

gql(`
    fragment PersonFields on Person {
        id
        gender
        firstName
        lastName
        birthdate
        avsNumber
        monthlySalary
        inFirstEducation
        nationality
        permitType
    }
`);

gql(`
    fragment CurriculumVitaeFields on CurriculumVitae {
        source
        link
        pdfDocumentUrl
        experiences {
            professionName
            yearsOfExperience
            yearsOfExperienceDecimal
        }
        trainings {
            trainingName
            educationLevel
        }
    }
`);

gql(`
    fragment WorkerProfileFields on WorkerProfile {
        __typename
        id
        avsNumber
        educationLevel
        yearsOfExperience
        maritalStatus
        maritalStatusFrom
        otherActivityPercent
        hasOtherActivity
        curriculumVitae {
            ...CurriculumVitaeFields
        }
        partner {
            ...PersonFields
        }
        hasChildren
        children {
            ...PersonFields    
        }
        hasFiscalAttestation
        churchMember
        weeklyResidenceCanton
        lppRegistrations {
            fund {
                ...LPPFundFields
            }
            registrationFormData
        }
        bankAccount {
            id
            iban
            bic
            beneficiary
        }
        swissOrHasPermitAnswer
        lastWorkPermit {
            type
            validFrom
            validTo
        }
        documents {
            id
            type
            title
            documentUrl
            asset {
                ...AssetFields
            }
       }
       relationshipCount
    }
`);

gql(`
    fragment ClientProfileFields on ClientProfile {
        __typename
        id
        businessEmail
        businessEmailVerified
        client {
            id
            name
            status
            uid
            status
            rejectedReason
            rejectedBy
            address {
                ...AddressFields
            }
            hoursPerWeekFullTime
            logoUrl
            ijmConfiguration
            canChangeIjmConfiguration
            lppConfiguration
            canChangeLppConfiguration            
            useLegalEmployer {
                ...LegalEmployerFields
            }
            signatureStatus
            contractEffectiveAsset {
                ...AssetFields
            }
            workerGroups {
                id
                name
                description
            }
            lang
            contactEmail
            contactPhoneNumber
        }
        clientRelationshipCount
        isPrivateClient
        canSignContracts
        canInviteWorker
    }
`);

gql(`
    fragment ClientInfoFields on ClientInfo {
        id
        name
        uid
        profileName
        phoneNumber
        email
        isPrivateClient
        isActive
        avatarUrl
        logoUrl
        verified
        address {
            ...AddressFields
        }
        hoursPerWeekFullTime
        deleted
        canSignContracts
        useLse
        status
        contactEmail
        contactPhoneNumber
        signatureCapacity
        signatureFunction
    }
`);

gql(`
    fragment WorkerInfoFields on WorkerInfo {
        id
        lang
        gender
        avatarUrl
        email
        name
        phoneNumber
        birthdate
        deleted
        workPermitStatus
        kycStatus
        address {
            ...AddressFields
        }
        educationLevel
        yearsOfExperience
        curriculumVitae {
            ...CurriculumVitaeFields
        }
        documents {
            id
            type
            title
            documentUrl
        }
        missionCount {
            total
            draft
            pendingAcceptation
            accepted
            ended
            terminated
            cancelled
        }
    }
`);

gql(`
    fragment UserFields on User {
        id
        email
        phoneNumber
        verified
        firstName
        lastName
        birthdate
        age
        gender
        avatarUrl
        expoPushToken
        firebasePushToken
        intercomUserId
        iosIntercomHmac
        androidIntercomHmac
        webIntercomHmac
        kycStatus {
            status
            reason
            reasonCode
            veriffUrl
        }
        avatarUrl
        workerProfile {
            ...WorkerProfileFields
        }
        clientProfiles {
            ...ClientProfileFields
        }
        workerInfo {
            ...WorkerInfoFields
        }
        clientInfos {
            ...ClientInfoFields
        }
        address {
            ...AddressFields
        }
        nationality
        isImpersonate
        impersonatedBy {
            id
            avatarUrl
            firstName
            lastName
        }
        lang
    }
`);

export const GET_USER = gql(`
    query CurrentUser {
        currentUser {
            ...UserFields
        }
    }
`);

export const GET_DEFAULT_PROFILE_TYPE = gql(`
    query GetDefaultProfileType {
        getDefaultProfileType
    }
`);

export const UPDATE_PUSH_TOKEN = gql(`
    mutation UpdatePushToken($expoPushToken: String, $firebasePushToken: String) {
        updateUser(
            userData: { expoPushToken: $expoPushToken, firebasePushToken: $firebasePushToken }
        ) {
            id
        }
    }
`);

export const UPDATE_USER = gql(`
    mutation UpdateUser($userData: UserInput!) {
        updateUser(userData: $userData) {
            ...UserFields
        }
    }
`);

export const DELETE_USER = gql(`
    mutation DeleteUser {
        deleteUser
    }
`);

export const DELETE_CURRENT_PROFILE = gql(`
    mutation DeleteCurrentProfile {
        deleteCurrentProfile
    }
`);

export const END_VERIFF_SESSION = gql(`
    mutation EndVeriffSession {
        verificationSubmitted
    }
`);

export const VERIFICATION_RESET = gql(`
    mutation VerificationReset {
        verificationReset
    }
`);
